/**
 * @generated SignedSource<<8cd6d81e4f4caca0ddd7ba23d6f3e2b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type backupsPage_ConfigBackupMutation$variables = Record<PropertyKey, never>;
export type backupsPage_ConfigBackupMutation$data = {
  readonly configBackup: {
    readonly configBackup: {
      readonly id: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type backupsPage_ConfigBackupMutation = {
  response: backupsPage_ConfigBackupMutation$data;
  variables: backupsPage_ConfigBackupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "ConfigBackup",
  "kind": "LinkedField",
  "name": "configBackup",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "backupsPage_ConfigBackupMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConfigBackupMutationPayload",
        "kind": "LinkedField",
        "name": "configBackup",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "backupsPage_ConfigBackupMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConfigBackupMutationPayload",
        "kind": "LinkedField",
        "name": "configBackup",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c421f87a2289c6f20ad9415e54d7410c",
    "id": null,
    "metadata": {},
    "name": "backupsPage_ConfigBackupMutation",
    "operationKind": "mutation",
    "text": "mutation backupsPage_ConfigBackupMutation {\n  configBackup {\n    configBackup {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b9acffc1b99eb485690c03120fa7b2de";

export default node;
